module.exports = __webpack_public_path__ + "img/go1.808fd7cb.png";